// Not generated from samples: written from Appboy::Communication::Segment::CalculatedFilterFilter.

import { z } from "zod";
import { common } from "../common";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const calculatedFilterFilterGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("calculated_filter_filter"),
  // "Included" is the only comparison CalculatedFilterFilter.allowed_comparisons offers.
  comparison_key: z.literal("7"),
  display_name: z.string(),
  // Only present when the filters_include_raw_values feature flipper is on. The definition id.
  raw_value: common.objectId.optional(),
  // CalculatedFilterFilter.display_value_for_definition: a processed definition carries
  // last_processed, one still processing is flagged disabled instead, and a deleted definition is
  // just { id, value: "[Deleted]" }.
  value: z.object({
    disabled: z.literal(true).optional(),
    disabled_reason: z.literal("processing").optional(),
    id: common.objectId,
    last_processed: common.dateTime.optional(),
    value: z.string(),
  }),
  varies_by_app_group: z.literal(true),
});
